itsoftApp.createModule("createScene", function () {
    var module = this;

    var initWebgl = function () {
        var canvasContainer = document.getElementById("canvas-3d");
        var preloader = document.getElementById("canvas-preloader");

        if (canvasContainer) {
            itsoftApp.loadScript("/assets/scripts/three-js/three.min.js", function () {
                itsoftApp.loadScript("/assets/scripts/three-js/WebGL.js", function () {
                    itsoftApp.loadScript("/assets/scripts/three-js/OrbitControls.min.js", function () {
                        // "use strict";

                        var isScroll = canvasContainer.classList.contains("js-scroll");
                        // перевод градусов в радианы

                        var degToRadians = function degToRadians(deg) {
                          return deg * Math.PI / 180;
                        };
                        // // определяем начальные значения ширины и высоты холста


                        var initialWidth = canvasContainer.clientWidth;
                        var initialHeight = canvasContainer.clientHeight;
                        /* Настройки для проецирования объектов на плоскость экрана: настройки 
                            перспективы и глубины рендеринга, положение точки, из которой пользователь 
                            смотрит на сцену хранятся в объекте Camera: */

                        var params = {
                          fov: 70,
                          aspect: initialWidth / initialHeight,
                          near: 1,
                          far: 1000
                        };

                        var setup3dInfrastructure = function setup3dInfrastructure() {
                          // функция для определения поведения холста и его содержимого при ресайзе
                          function resize() {
                            var canvas = renderer.domElement;
                            var width = canvasContainer.clientWidth;
                            var height = canvasContainer.clientHeight;
                            if (height < 1 || width < 1) return; // 3.1. Camera resize

                            if (width > height) {
                              this.camera.fov = 35;
                            } else {
                              this.camera.fov = 32 * height / Math.min(width * 1.3, height);
                            }

                            this.camera.aspect = width / height;
                            this.camera.updateProjectionMatrix(); // 3.3. Renderer resize

                            this.renderer.setSize(width, height);
                            return this;
                          }
                          /* Объект, отвечающий за рендеринг */


                          var renderer = new THREE.WebGLRenderer({
                            alpha: true,
                            antialias: true
                          });
                          /* Здесь указываем следующее: каким цветом нужно очищать экран перед очередным циклом рендеринга,
                          devicePixelRatio для различных экранов, чтобы картинка была чёткой, и размеры canvas. */

                          renderer.setPixelRatio(window.devicePixelRatio);
                          renderer.setSize(initialWidth, initialHeight);
                          renderer.setClearColor(0x000000, 0);
                          /* Чтобы можно было рендерить объекты на canvas в Three.js,
                          необходимо описать их все и сгруппировать в специальном объекте Scene*/

                          var scene = new THREE.Scene();
                          /* Первый параметр — угол перспективы, второй — соотношение сторон canvas, третий и четвёртый параметры
                          — наименьшее и наибольшее значения z-координаты, которые будут рендериться.*/

                          var camera = new THREE.PerspectiveCamera(params.fov, params.aspect, params.near, params.far); // инфраструктра включает в себя рендерер, сцену, камеру

                          var infrastructure = {
                            renderer: renderer,
                            scene: scene,
                            camera: camera
                          };
                          infrastructure.resize = resize.bind(infrastructure);
                          return infrastructure;
                        };
                        /* Добавление в DOM */


                        var appendRendererToDOMElement = function appendRendererToDOMElement(renderer, targetNode) {
                          targetNode.appendChild(renderer.domElement);
                        };


                        function start() {
                          // проверяем поддержку WebGL браузером
                          // var hasWebGLSupport = function () {
                          //   return THREE.WEBGL.isWebGLAvailable() || THREE.WEBGL.isWebGL2Available();
                          // }();
                          // настраиваем инфраструктуру

                          // Добавление препарата на сцену
                          var infrastructure = setup3dInfrastructure();
                          var distanceToCamera = 15;
                          infrastructure.camera.position.z = distanceToCamera;
                          var halfHeight = distanceToCamera / Math.tan(params.fov / 2 * Math.PI / 180);
                          var textureWidth = 395;
                          var textureHeight = 184;
                          var bgTextureWidth = 827;
                          var bgTextureHeight = 135;
                          var xScale = 6.2;
                          var yScale = xScale * textureHeight / textureWidth;
                          var xBgScale = 13.1;
                          var yBgScale = xBgScale * bgTextureHeight / bgTextureWidth;
                          var objects = [];
                          var map = new THREE.TextureLoader().load("/media/images/features-preparation.png");
                          map.minFilter = THREE.LinearFilter;
                          map.wrapS = THREE.ClampToEdgeWrapping;
                          map.wrapT = THREE.ClampToEdgeWrapping;
                          var spriteMaterial = new THREE.SpriteMaterial({
                            map: map
                          });
                          var sprite = new THREE.Sprite(spriteMaterial);
                          sprite.scale.x = xScale;
                          sprite.scale.y = yScale;
                          sprite.position.y = 0.26;
                          infrastructure.scene.add(sprite); // фон для сцены

                          // создание орбиты

                          var bgMap = new THREE.TextureLoader().load("/media/images/features-ellipse.png");
                          bgMap.minFilter = THREE.LinearFilter;
                          map.wrapS = THREE.ClampToEdgeWrapping;
                          map.wrapT = THREE.ClampToEdgeWrapping;
                          var bgMaterial = new THREE.SpriteMaterial({
                            map: bgMap
                          });
                          var bgSprite = new THREE.Sprite(bgMaterial);
                          bgSprite.scale.x = xBgScale;
                          bgSprite.scale.y = yBgScale;
                          bgSprite.position.y = -0.5;
                          infrastructure.scene.add(bgSprite);

                          var light = new THREE.PointLight(0xffffff, 1, 0); // Specify the light's position

                          light.position.set(1, 1, 100); // Add the light to the scene

                          infrastructure.scene.add(light);

                          // создание иконки и текста
                          // 
                          var count = 4;

                          for (var i = 0; i < count; i++) {
                            var xCircleScale = 0.84; //0.3;

                            var textureCircleWidth = 90;
                            var textureCircleHeight = 90;
                            var yCircleScale = xCircleScale * textureCircleHeight / textureCircleWidth;

                            var slideMap = new THREE.TextureLoader().load("/media/images/icon-item-" + (i + 1) + "@2x.png");
                            var t = i / count * 2 * Math.PI;
                            var wrapper = new THREE.Object3D();
                            // настройки интерполяции
                            slideMap.minFilter = THREE.LinearFilter;
                            slideMap.wrapS = THREE.ClampToEdgeWrapping;
                            slideMap.wrapT = THREE.ClampToEdgeWrapping;
                            var slideSpriteMaterial = new THREE.SpriteMaterial({
                              map: slideMap
                            });
                            var slideSprite = new THREE.Sprite(slideSpriteMaterial);
                            wrapper.position.x = Math.cos(t) * 6.2;
                            wrapper.position.z = Math.sin(t) * 6.2;
                            slideSprite.scale.x = xCircleScale;
                            slideSprite.scale.y = yCircleScale;
                            wrapper.add(slideSprite);


                            var xLabelScale = 2.7; //0.3;

                            var textureLabelWidth = 286;
                            var textureLabelHeight = 112;
                            var yLabelScale = xLabelScale * textureLabelHeight / textureLabelWidth;
                            var labelMap = new THREE.TextureLoader().load("/media/images/item-text-" + (i + 1) + ".png");
                            labelMap.minFilter = THREE.LinearFilter;
                            labelMap.wrapS = THREE.ClampToEdgeWrapping;
                            labelMap.wrapT = THREE.ClampToEdgeWrapping;
                            var labelSpriteMaterial = new THREE.SpriteMaterial({
                              map: labelMap
                            });
                            var labelSprite = new THREE.Sprite(labelSpriteMaterial); // wrapper.attach(labelSprite)


                            labelSprite.position.y = -1;
                            // wrapper.attach(labelSprite)
                            // labelSprite.position.x = Math.cos(t) * 2;
                            // labelSprite.position.z = Math.sin(t) * 2;
                            labelSprite.scale.x = xLabelScale;
                            labelSprite.scale.y = yLabelScale;
                            wrapper.add(labelSprite);
                            var object = {
                              slideSprite: slideSprite,
                              labelSprite: labelSprite
                            }; // wrapper.add(label);

                            infrastructure.scene.add(wrapper);
                            objects.push(object);
                          }

                          if (!isScroll) {
                            var controls = new THREE.OrbitControls(infrastructure.camera, infrastructure.renderer.domElement);
                            controls.minPolarAngle = degToRadians(82);
                            controls.maxPolarAngle = degToRadians(82);
                            controls.enableZoom = false;
                            controls.enableDamping = true;
                            controls.rotateSpeed = 0.5;
                            controls.autoRotate = true;
                            controls.autoRotateSpeed = 0.2;
                            controls.maxDistance = distanceToCamera;
                            controls.minDistance = distanceToCamera;
                            controls.keys = {
                              LEFT: "",
                              UP: "",
                              RIGHT: "",
                              BOTTOM: ""
                            };
                          } //

                          var onEnterFrame = function onEnterFrame(infrastructure) {
                            if (infrastructure.resizeInProgress) {
                              infrastructure.resize();
                            }

                            infrastructure.renderer.render(infrastructure.scene, infrastructure.camera);
                            infrastructure.resizeInProgress = false;

                            if (!isScroll) {
                              controls.update();
                            }

                            requestAnimationFrame(function () {
                              onEnterFrame(infrastructure);
                            });
                          };

                          requestAnimationFrame(function () {
                            onEnterFrame(infrastructure);
                          }); //
                          // Resize:

                          infrastructure.resize();
                          window.addEventListener("resize", function () {
                            infrastructure.resizeInProgress = true;
                          }); //
                          // Add to DOM:

                          appendRendererToDOMElement(infrastructure.renderer, canvasContainer);
                        }

                        start();
                    });
                });
            });
        };
    }

    module.callback = initWebgl;
});